/**
 * Collection Hub Quick View Functionality
 * Opens product popup similar to addons popup
 */

(function() {
  'use strict';

  let quickViewModal = null;
  let currentProduct = null;

  // Initialize quick view modal structure
  function initQuickView() {
    // Create modal HTML if it doesn't exist
    if (!document.getElementById('chub-quickview-modal')) {
      const modalHTML = `
        <div id="chub-quickview-modal" class="chub-quickview-modal">
          <div class="chub-quickview-modal-content">
            <button class="chub-quickview-modal-close" aria-label="Close">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 6L18 18" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="chub-quickview-modal-body">
              <div class="chub-quickview-modal-images">
                <div class="chub-quickview-image-container">
                  <img class="chub-quickview-modal-main-image" src="" alt="" />
                </div>
              </div>
              <div class="chub-quickview-modal-details">
                <h2 class="chub-quickview-modal-title"></h2>
                <div class="chub-quickview-modal-price">
                  <span class="price"></span>
                  <span class="compare-price" style="display: none;"></span>
                </div>
                <div class="chub-quickview-modal-variants"></div>
                <button class="chub-quickview-modal-add-btn">ADD TO CART</button>
              </div>
            </div>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', modalHTML);
      quickViewModal = document.getElementById('chub-quickview-modal');
      attachEventListeners();
    } else {
      quickViewModal = document.getElementById('chub-quickview-modal');
    }
  }

  // Show loading state
  function showLoadingState() {
    const modalBody = quickViewModal.querySelector('.chub-quickview-modal-body');
    if (!modalBody) return;

    // Replace entire modal body with loading state
    modalBody.innerHTML = `
      <div class="chub-quickview-modal-images">
        <div class="chub-quickview-loading">
          <div class="chub-quickview-spinner">
            <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
              <circle cx="25" cy="25" r="20" fill="none" stroke="#333" stroke-width="3" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416" opacity="0.3"></circle>
              <circle cx="25" cy="25" r="20" fill="none" stroke="#333" stroke-width="3" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                <animate attributeName="stroke-dasharray" dur="1.5s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
                <animate attributeName="stroke-dashoffset" dur="1.5s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
              </circle>
            </svg>
          </div>
          <p class="chub-quickview-loading-text">Loading product...</p>
        </div>
      </div>
      <div class="chub-quickview-modal-details">
        <div class="chub-quickview-loading-details">
          <div class="chub-quickview-skeleton-title"></div>
          <div class="chub-quickview-skeleton-price"></div>
          <div class="chub-quickview-skeleton-variant"></div>
          <div class="chub-quickview-skeleton-variant"></div>
          <div class="chub-quickview-skeleton-button"></div>
        </div>
      </div>
    `;
  }

  // Attach event listeners
  function attachEventListeners() {
    if (!quickViewModal) return;
    
    // Close modal button
    const closeBtn = quickViewModal.querySelector('.chub-quickview-modal-close');
    if (closeBtn) {
      // Remove old listener if exists and add new one
      closeBtn.replaceWith(closeBtn.cloneNode(true));
      quickViewModal.querySelector('.chub-quickview-modal-close').addEventListener('click', closeQuickView);
    }

    // Close on backdrop click
    quickViewModal.addEventListener('click', function(e) {
      if (e.target === quickViewModal) {
        closeQuickView();
      }
    });

    // Close on ESC key (only add once)
    if (!document.hasQuickViewEscListener) {
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && quickViewModal && quickViewModal.classList.contains('active')) {
          closeQuickView();
        }
      });
      document.hasQuickViewEscListener = true;
    }
  }

  // Handle quick view button clicks (using event delegation - only add once)
  if (!document.hasQuickViewClickListener) {
    document.addEventListener('click', function(e) {
      if (e.target.closest('.chub-quick-view-btn')) {
        e.preventDefault();
        e.stopPropagation();
        const btn = e.target.closest('.chub-quick-view-btn');
        const productHandle = btn.getAttribute('data-product-handle');
        if (productHandle) {
          // Ensure modal is initialized
          if (!quickViewModal) {
            initQuickView();
          }
          openQuickView(productHandle);
        }
      }
    });
    document.hasQuickViewClickListener = true;
  }

  // Open quick view
  function openQuickView(productHandle) {
    // Ensure modal is initialized
    if (!quickViewModal) {
      initQuickView();
      // Wait a bit for DOM to be ready
      setTimeout(() => {
        openQuickView(productHandle);
      }, 50);
      return;
    }

    // Show modal and loading state
    quickViewModal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent background scroll
    
    showLoadingState();

    // Try to fetch product JSON first (Shopify AJAX API)
    fetch(`/products/${productHandle}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then(productData => {
        // Transform Shopify product JSON to our format
        const transformedData = transformShopifyProduct(productData);
        if (!transformedData || !transformedData.id) {
          throw new Error('Invalid product data received');
        }
        renderProductData(transformedData);
      })
      .catch(error => {
        console.error('Error fetching product JSON:', error);
        // Fallback: fetch HTML version and parse
        fetch(`/products/${productHandle}`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}`);
            }
            return response.text();
          })
          .then(html => {
            if (!html || html.length === 0) {
              throw new Error('Empty HTML response');
            }
            parseProductHTML(html, productHandle);
          })
          .catch(err => {
            console.error('Error loading product:', err);
            showErrorState(productHandle);
          });
      });
  }

  // Transform Shopify product JSON to our format
  function transformShopifyProduct(shopifyProduct) {
    if (!shopifyProduct) {
      return null;
    }

    // Handle featured image - can be string URL or object
    let featuredImage = shopifyProduct.featured_image;
    if (typeof featuredImage === 'string') {
      featuredImage = featuredImage;
    } else if (featuredImage && featuredImage.src) {
      featuredImage = featuredImage.src;
    } else if (shopifyProduct.images && shopifyProduct.images.length > 0) {
      featuredImage = typeof shopifyProduct.images[0] === 'string' 
        ? shopifyProduct.images[0] 
        : (shopifyProduct.images[0].src || shopifyProduct.images[0]);
    }

    // Process images array
    const images = (shopifyProduct.images || []).map(img => {
      return typeof img === 'string' ? img : (img.src || img);
    });

    // Process media array (for matching images by alt text)
    const media = (shopifyProduct.media || []).map(mediaItem => {
      if (typeof mediaItem === 'string') {
        return { src: mediaItem, media_type: 'image', alt: '' };
      }
      return {
        src: mediaItem.src || mediaItem,
        media_type: mediaItem.media_type || 'image',
        alt: mediaItem.alt || ''
      };
    });

    return {
      id: shopifyProduct.id,
      title: shopifyProduct.title || '',
      handle: shopifyProduct.handle || '',
      description: shopifyProduct.description || '',
      vendor: shopifyProduct.vendor || '',
      featured_image: featuredImage,
      images: images,
      media: media,
      variants: (shopifyProduct.variants || []).map(variant => ({
        id: variant.id,
        title: variant.title || '',
        price: variant.price || 0,
        compare_at_price: variant.compare_at_price || null,
        available: variant.available !== false,
        option1: variant.option1 || null,
        option2: variant.option2 || null,
        option3: variant.option3 || null,
        options: [variant.option1, variant.option2, variant.option3].filter(Boolean),
        featured_image: variant.featured_image || null
      })),
      options: (shopifyProduct.options || []).map(option => ({
        name: typeof option === 'string' ? option : (option.name || ''),
        values: typeof option === 'string' ? [] : (option.values || [])
      }))
    };
  }

  // Parse product HTML
  function parseProductHTML(html, productHandle) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Try multiple methods to extract product data
    let productData = null;

    // Method 1: Look for script tag with product JSON
    const productJsonScripts = doc.querySelectorAll('script[type="application/json"]');
    for (const script of productJsonScripts) {
      try {
        const data = JSON.parse(script.textContent);
        // Check if it looks like product data
        if (data && (data.id || data.title || data.variants)) {
          productData = data;
          break;
        }
      } catch (e) {
        // Not valid JSON, continue
      }
    }

    // Method 2: Look for script with class containing "prod-json" or similar
    if (!productData) {
      const prodJsonScript = doc.querySelector('script.prod-json-js, script[class*="prod-json"]');
      if (prodJsonScript) {
        try {
          productData = JSON.parse(prodJsonScript.textContent);
        } catch (e) {
          console.error('Error parsing product JSON from script:', e);
        }
      }
    }

    // Method 3: Try to extract from inline scripts
    if (!productData) {
      const inlineScripts = Array.from(doc.querySelectorAll('script:not([src])'));
      for (const script of inlineScripts) {
        const content = script.textContent;
        // Look for window.product or product: patterns
        const patterns = [
          /window\.product\s*=\s*({[\s\S]*?});/,
          /product:\s*({[\s\S]*?}),/,
          /"product":\s*({[\s\S]*?})/
        ];
        
        for (const pattern of patterns) {
          const match = content.match(pattern);
          if (match) {
            try {
              productData = JSON.parse(match[1]);
              if (productData && (productData.id || productData.title || productData.variants)) {
                break;
              }
            } catch (e) {
              // Continue to next pattern
            }
          }
        }
        if (productData) break;
      }
    }

    if (productData) {
      // Ensure it's in the right format
      if (!productData.variants && productData.id) {
        // Might need transformation
        productData = transformShopifyProduct(productData);
      }
      renderProductData(productData);
    } else {
      // Fallback: try to get basic info from HTML
      const title = doc.querySelector('h1.product__title, .product__title, h1')?.textContent?.trim() || 'Product';
      const priceEl = doc.querySelector('.price, .product__price, [class*="price"]');
      const price = priceEl?.textContent?.trim() || '';
      const imageEl = doc.querySelector('.product__media img, .product-image img, [class*="product"] img');
      const imageSrc = imageEl?.src || imageEl?.getAttribute('data-src') || imageEl?.getAttribute('srcset')?.split(',')[0]?.trim().split(' ')[0] || '';

      renderProductFallback({
        title,
        price,
        image: imageSrc,
        handle: productHandle
      });
    }
  }

  // Render product data
  function renderProductData(product) {
    if (!product) {
      console.error('No product data to render');
      return;
    }

    currentProduct = product;

    const modalBody = quickViewModal.querySelector('.chub-quickview-modal-body');
    if (!modalBody) {
      console.error('Modal body not found');
      return;
    }

    // Always restore structure - loading state replaces it
    modalBody.innerHTML = `
            <div class="chub-quickview-modal-images">
              <div class="chub-quickview-image-container">
                <img class="chub-quickview-modal-main-image" src="" alt="" />
              </div>
            </div>
            <div class="chub-quickview-modal-details">
              <h2 class="chub-quickview-modal-title"></h2>
              <div class="chub-quickview-modal-price">
                <span class="price"></span>
                <span class="compare-price" style="display: none;"></span>
              </div>
              <div class="chub-quickview-modal-variants"></div>
              <button class="chub-quickview-modal-add-btn">ADD TO CART</button>
            </div>
          `;

    // Now query the elements
    const imagesContainer = modalBody.querySelector('.chub-quickview-modal-images .chub-quickview-image-container');
    const detailsContainer = modalBody.querySelector('.chub-quickview-modal-details');
    
    if (!detailsContainer) {
      console.error('Details container not found after restoration');
      return;
    }

    const titleEl = detailsContainer.querySelector('.chub-quickview-modal-title');
    const priceEl = detailsContainer.querySelector('.chub-quickview-modal-price .price');
    const comparePriceEl = detailsContainer.querySelector('.chub-quickview-modal-price .compare-price');
    const variantsContainer = detailsContainer.querySelector('.chub-quickview-modal-variants');
    const addBtn = detailsContainer.querySelector('.chub-quickview-modal-add-btn');

    // Set title
    if (titleEl) {
      titleEl.textContent = product.title || 'Product';
    }

    // Set image
    if (imagesContainer) {
      const featuredImage = product.featured_image || (product.images && product.images.length > 0 ? product.images[0] : null);
      if (featuredImage) {
        const imgSrc = typeof featuredImage === 'string' ? featuredImage : (featuredImage.src || featuredImage);
        let img = imagesContainer.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.className = 'chub-quickview-modal-main-image';
          imagesContainer.appendChild(img);
        }
        img.src = imgSrc;
        img.alt = product.title || 'Product image';
      }
    }

    // Set price and initial variant
    let selectedVariant = null;
    if (product.variants && product.variants.length > 0) {
      selectedVariant = product.variants[0];
      
      if (priceEl) {
        priceEl.textContent = formatMoney(selectedVariant.price);
      }
      
      if (comparePriceEl) {
        if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
          comparePriceEl.textContent = formatMoney(selectedVariant.compare_at_price);
          comparePriceEl.style.display = 'inline';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
    }

    // Render variants
    if (variantsContainer) {
      renderVariants(product, variantsContainer, priceEl, comparePriceEl, addBtn);
    }

    // Update add button with initial variant
    if (addBtn) {
      updateAddButton(addBtn, selectedVariant);
    }
  }

  // Render variants
  function renderVariants(product, container, priceEl, comparePriceEl, addBtn) {
    container.innerHTML = '';

    if (!product.options || product.options.length === 0) {
      return;
    }

    const selectedOptions = {};

    product.options.forEach((option, optionIndex) => {
      const optionName = option.name || option;
      const optionValues = option.values || [];

      if (optionValues.length === 0) return;

      const variantGroup = document.createElement('div');
      variantGroup.className = 'chub-quickview-variant-group';

      const label = document.createElement('label');
      label.textContent = `${optionName}:`;
      variantGroup.appendChild(label);

      const optionsContainer = document.createElement('div');
      optionsContainer.className = optionName.toLowerCase().includes('color') || optionName.toLowerCase().includes('colour')
        ? 'chub-quickview-color-options'
        : 'chub-quickview-size-options';

      optionValues.forEach((value, valueIndex) => {
        const optionBtn = document.createElement('button');
        optionBtn.className = optionName.toLowerCase().includes('color') || optionName.toLowerCase().includes('colour')
          ? 'chub-quickview-color-option'
          : 'chub-quickview-size-option';
        optionBtn.textContent = value;
        optionBtn.setAttribute('data-option-index', optionIndex);
        optionBtn.setAttribute('data-option-value', value);

        // Select first option by default
        if (valueIndex === 0) {
          optionBtn.classList.add('selected');
          selectedOptions[optionIndex] = value;
        }

        optionBtn.addEventListener('click', function() {
          // Update selection
          optionsContainer.querySelectorAll('button').forEach(btn => btn.classList.remove('selected'));
          optionBtn.classList.add('selected');
          selectedOptions[optionIndex] = value;

          // Find matching variant
          const variant = findVariantByOptions(product.variants, selectedOptions);
          if (variant) {
            updatePrice(variant, priceEl, comparePriceEl);
            updateAddButton(addBtn, variant);
            updateImage(variant, product);
          }
        });

        optionsContainer.appendChild(optionBtn);
      });

      variantGroup.appendChild(optionsContainer);
      container.appendChild(variantGroup);
    });
  }

  // Find variant by selected options
  function findVariantByOptions(variants, selectedOptions) {
    if (!variants || variants.length === 0) return null;

    // If no options selected, return first variant
    if (Object.keys(selectedOptions).length === 0) {
      return variants[0];
    }

    // Find variant matching all selected options
    return variants.find(variant => {
      return Object.keys(selectedOptions).every(optionIndex => {
        const optionValue = selectedOptions[optionIndex];
        return variant.options && variant.options[parseInt(optionIndex)] === optionValue;
      });
    }) || variants[0];
  }

  // Update price
  function updatePrice(variant, priceEl, comparePriceEl) {
    if (!variant) return;

    priceEl.textContent = formatMoney(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      comparePriceEl.textContent = formatMoney(variant.compare_at_price);
      comparePriceEl.style.display = 'inline';
    } else {
      comparePriceEl.style.display = 'none';
    }
  }

  // Update add button
  function updateAddButton(btn, variant) {
    if (!variant) {
      btn.disabled = true;
      btn.textContent = 'SELECT OPTIONS';
      return;
    }

    if (variant.available === false || variant.available === 0) {
      btn.disabled = true;
      btn.textContent = 'SOLD OUT';
      btn.onclick = null;
    } else {
      btn.disabled = false;
      btn.textContent = 'ADD TO CART';
      btn.onclick = function() {
        addToCart(variant.id);
      };
    }
  }

  // Update image based on variant
  function updateImage(variant, product) {
    if (!variant || !product) return;

    const imgEl = quickViewModal.querySelector('.chub-quickview-modal-main-image');
    if (!imgEl) return;

    // Check if variant has featured_image
    let imageSrc = null;
    
    if (variant.featured_image) {
      // Variant has its own featured image
      imageSrc = typeof variant.featured_image === 'string' 
        ? variant.featured_image 
        : (variant.featured_image.src || variant.featured_image);
    } else if (product.images && product.images.length > 0) {
      // Try to find image matching variant's option1 (color)
      if (variant.option1 && product.media) {
        const matchingMedia = product.media.find(media => 
          media.media_type === 'image' && 
          (media.alt === variant.option1 || media.alt?.includes(variant.option1))
        );
        if (matchingMedia) {
          imageSrc = typeof matchingMedia === 'string' ? matchingMedia : (matchingMedia.src || matchingMedia);
        }
      }
      
      // Fallback to first product image
      if (!imageSrc) {
        imageSrc = typeof product.images[0] === 'string' 
          ? product.images[0] 
          : (product.images[0].src || product.images[0]);
      }
    } else if (product.featured_image) {
      // Use product featured image
      imageSrc = typeof product.featured_image === 'string' 
        ? product.featured_image 
        : (product.featured_image.src || product.featured_image);
    }

    // Update image if we found one
    if (imageSrc) {
      imgEl.src = imageSrc;
      // Add fade effect
      imgEl.style.opacity = '0.7';
      imgEl.style.transition = 'opacity 0.3s ease';
      setTimeout(() => {
        imgEl.style.opacity = '1';
      }, 150);
    }
  }

  // Add to cart
  function addToCart(variantId) {
    const addBtn = quickViewModal.querySelector('.chub-quickview-modal-add-btn');
    const originalText = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'ADDING...';

    // Use FormData format (same as product-form.js)
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    // Get sections to render
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        return response.text().then(text => {
          throw new Error(`HTTP ${response.status}: ${text}`);
        });
      }
      return response.json();
    })
    .then(data => {
      // Check for errors (Shopify returns {status: 422, description: "..."} on error)
      if (data.status) {
        alert(data.description || 'Error adding to cart');
        addBtn.textContent = originalText;
        addBtn.disabled = false;
        return;
      }

      // Trigger cart update event
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Close popup first
      closeQuickView();
      
      // Open cart drawer
      if (cartDrawer) {
        if (typeof cartDrawer.renderContents === 'function') {
          // Response should have sections property if we included sections in the request
          cartDrawer.renderContents(data);
        } else {
          // Fallback: fetch sections and open
          fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(response => response.json())
            .then(sections => {
              if (typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents({
                  sections: sections
                });
              } else {
                cartDrawer.open();
              }
            })
            .catch(err => {
              console.error('Error fetching cart sections:', err);
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              }
            });
        }
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      addBtn.textContent = 'ERROR - TRY AGAIN';
      addBtn.disabled = false;
      
      setTimeout(() => {
        addBtn.textContent = originalText;
      }, 2000);
    });
  }

  // Render fallback (when product data is not available)
  function renderProductFallback(data) {
    const modalBody = quickViewModal.querySelector('.chub-quickview-modal-body');
    modalBody.innerHTML = `
      <div class="chub-quickview-modal-images">
        <div class="chub-quickview-image-container">
          <img class="chub-quickview-modal-main-image" src="${data.image}" alt="${data.title}" />
        </div>
      </div>
      <div class="chub-quickview-modal-details">
        <h2 class="chub-quickview-modal-title">${data.title}</h2>
        <div class="chub-quickview-modal-price">
          <span class="price">${data.price}</span>
        </div>
        <a href="/products/${data.handle}" class="chub-quickview-modal-add-btn" style="text-decoration: none; display: block; text-align: center;">
          VIEW PRODUCT
        </a>
      </div>
    `;
  }

  // Show error state
  function showErrorState(productHandle) {
    const modalBody = quickViewModal.querySelector('.chub-quickview-modal-body');
    if (!modalBody) return;

    const imagesContainer = modalBody.querySelector('.chub-quickview-modal-images');
    const detailsContainer = modalBody.querySelector('.chub-quickview-modal-details');
    
    if (imagesContainer) {
      imagesContainer.innerHTML = `
        <div class="chub-quickview-error">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #999; margin-bottom: 20px;">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
      `;
    }

    if (detailsContainer) {
      detailsContainer.innerHTML = `
        <div class="chub-quickview-error-content">
          <h2 class="chub-quickview-error-title">Unable to Load Product</h2>
          <p class="chub-quickview-error-message">We're having trouble loading this product. Please try again or visit the product page.</p>
          <a href="/products/${productHandle}" class="chub-quickview-error-link">View Product Page</a>
        </div>
      `;
    }
  }

  // Close quick view
  function closeQuickView() {
    if (quickViewModal) {
      quickViewModal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scroll
      currentProduct = null;
      // Reset modal content for next time
      setTimeout(() => {
        const modalBody = quickViewModal.querySelector('.chub-quickview-modal-body');
        if (modalBody) {
          modalBody.innerHTML = `
            <div class="chub-quickview-modal-images">
              <div class="chub-quickview-image-container">
                <img class="chub-quickview-modal-main-image" src="" alt="" />
              </div>
            </div>
            <div class="chub-quickview-modal-details">
              <h2 class="chub-quickview-modal-title"></h2>
              <div class="chub-quickview-modal-price">
                <span class="price"></span>
                <span class="compare-price" style="display: none;"></span>
              </div>
              <div class="chub-quickview-modal-variants"></div>
              <button class="chub-quickview-modal-add-btn">ADD TO CART</button>
            </div>
          `;
        }
      }, 300);
    }
  }

  // Format money
  function formatMoney(cents) {
    if (typeof cents !== 'number') {
      cents = parseFloat(cents) || 0;
    }
    
    // Use Shopify's money format if available
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    
    // Fallback formatting
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initQuickView();
    });
  } else {
    initQuickView();
  }

  // Re-initialize on section load (Shopify theme editor)
  document.addEventListener('shopify:section:load', function() {
    initQuickView();
  });

})();

